// extracted by mini-css-extract-plugin
export default {"title-section":"TitleSection_title-section__1YvpP"};